/** @format */

/**export const API_URL = "https://apisaludtotal.pol.una.py"; */
/**export const API_URL = "https://backend-core-covid19-production.up.railway.app"; */

export const API_URL = process.env.REACT_APP_API_URL || "https://backend-core-covid19-production.up.railway.app";
